"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _default = {
  DRAFT: _vars.COLOURS.grey.mischka.russian,
  PENDING_MASTER: _vars.COLOURS.cyan.jungleGreen.monkey,
  EDITING: _vars.COLOURS.cyan.jungleGreen.monkey,
  INTERNAL_REVIEW: _vars.COLOURS.cyan.jungleGreen.monkey,
  PENDING_REVIEW: _vars.COLOURS.yellow.goldenTainoi,
  APPROVED: _vars.COLOURS.mono.black,
  ON_HOLD: _vars.COLOURS.red.redApple,
  AT_RISK: _vars.COLOURS.red.redApple
};
exports.default = _default;